<template>
    <div class="spinner-container">
      <div class="spinner" />
    </div>
</template>
<style>
  .spinner-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100vw;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background-color: rgba(0,0,0,0.5);
    /* position: absolute; */
    z-index: 9998;
  }
  .spinner {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 5px solid #e0e0e0;
    border-bottom: 5px solid #ffd814;
    animation: spin 1s linear infinite;
    position: absolute;
    top: 50%;
    left: 50%;
    z-index: 9999;
    transform: translate(-50%, -50%);
  }
  @keyframes spin {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
</style>
  